import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase, Row } from 'styles/components/layout'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  left: -${em(36)};
  height: ${em(540)};
  margin-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    right: -${em(40)};
    top: 30%;
    left: initial;
    height: ${em(450)};
  }

  ${p => p.theme.mq.upLg} {
    right: 0;
    top: ${em(40)};
    left: initial;
    height: ${em(500)};
  }
`
export const ChartWrapper = styled.div`
    position: absolute;
    top: ${em(237)};
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: ${em(220)};
    height: ${em(245)};

  ${p => p.theme.mq.upMd} {
    top: ${em(185)};
    right: initial;
    left: ${em(100)};
  }

  ${p => p.theme.mq.upLg} {
    top: ${em(222)};
    right: initial;
    height: ${em(300)};
    width: ${em(210)};
    left: ${em(140)};
  }
}
`

export const BoxBaseStyled = styled(BoxBase)`
  background: ${p => p.theme.colors.lilacDark};
  padding-bottom: ${em(40)};
  overflow: hidden;

  ${p => p.theme.mq.upMd} {
    padding-bottom: ${em(100)};
    min-height: ${em(645)};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${em(600)};
  }
`

export const RowStyled = styled(Row)`
  margin-bottom: ${em(30)};
`
